import Axios from 'axios';
import React, { Component } from 'react';
import { Card, Button } from 'react-bootstrap';
import AdminAddPrinter from './adminAddPrinter';
import AdminPrinter from './adminPrinter';
import { connect } from 'react-redux';

class Printers extends Component {
    state = {
        addPrinterOpen: false,
        printers: {},
        lastUpdated: 0,
        printerIds: []

    }
    timeouts = {}
    componentDidMount() {
        this.getAllPrinters()
    }
    getAllPrinters = async () => {
        await Axios.get("/api/printers/get/all").then(res => {
            this.setState({ printerIds: res.data.printers }, () => {
                this.pollPrinters()
            })

        })
    }
    pollPrinters = async () => {
        for (let printer of this.state.printerIds) {
            this.getPrinterInfo(printer)
        }
    }
    getPrinterInfo = async (id) => {
        await Axios.post("/api/printers/get/status/by/id", { id: id }).then(res => {
            let printersCopy = this.state.printers
            printersCopy[res.data.printer.printer._id] = res.data.printer
            this.setState({ printers: printersCopy }, () => {
                this.timeouts[id] = setTimeout(() => {
                    this.getPrinterInfo(id)
                }, 1000)
            })
        })
    }

    closeAddPrinter = () => {
        this.setState({ addPrinterOpen: false })
    }
    componentWillUnmount() {
        for (let id in this.state.printers) {
            clearTimeout(this.timeouts[id])
        }
    }

    render() {
        let printers = []
        let darkmode = this.props.user ? this.props.user.darkmode : true

        for (let id in this.state.printers) {
            printers.push(
                <AdminPrinter darkmode={darkmode} data={this.state.printers[id]} />)
        }

        return (<div>
            <Card style={{ width: "80%", margin: "auto", textAlign: "center" }}>
                <Card.Header className={darkmode ? "darkmode-card-header" : "lightmode-card-header"}>
                    Printers (last checked: {this.state.lastUpdated})
                </Card.Header>
                <div className={darkmode ? "darkmode-card-content" : "lightmode-card-content"}>
                    <Button onClick={() => this.setState({ addPrinterOpen: true })}>Add Printer</Button>
                    {printers}

                </div>

            </Card>


            <AdminAddPrinter close={this.closeAddPrinter} show={this.state.addPrinterOpen} />
        </div>);
    }
}

function mapStateToProps(state) {
    return {
        user: state.user
    }
}
function mapDispatchToProps(dispatch) {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Printers);